import React, { useState, Fragment, useEffect } from 'react';
import { Row, Input, Label, Card, CardBody, Button } from 'reactstrap';
import Switch from 'rc-switch';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { putAPI_Update_DataRetention } from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';

export default function BusinessDataPolicy({
  propertyId,
  property,
  superAdmin,
}) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
    property !== undefined && !property.isTicketStore
  );
  const [automateTicket, setAutomateTicket] = useState(
    property?.automateTicket ?? false
  );
  const [propertyDataPolicy, setPropertyDataPolicy] = useState({
    isTicketStore: true,
    automateTicket: false,
    conversationPeriod: 0,
    ticketPeriod: 0,
    contactInfoPeriod: 0,
    updator: 'admin',
  });
  useEffect(() => {
    if (property !== undefined) {
      setPropertyDataPolicy({
        automateTicket: property?.automateTicket ?? false,
        isTicketStore: property.isTicketStore,
        topics: property?.topics,
        conversationPeriod: property.conversationPeriod,
        ticketPeriod: property.ticketPeriod,
        contactInfoPeriod: property.contactInfoPeriod,
      });
    }
  }, [property]);
  const handleSwitchChange = (value) => {
    setCheckedPrimarySmall(value);
    setPropertyDataPolicy({
      ...propertyDataPolicy,
      isTicketStore: !value,
    });
  };
  const handleAutomateTicket = (value) => {
    setAutomateTicket(value);
    setPropertyDataPolicy({
      ...propertyDataPolicy,
      automateTicket: value,
    });
  };
  const handleChange = (e) => {
    setPropertyDataPolicy({
      ...propertyDataPolicy,
      [e.target.name]: e.target.value,
    });
  };
  const handleSave = () => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_DataRetention}/${propertyId}`,
      data: propertyDataPolicy,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        NotificationManager.success(
          '',
          'data policy updated successfully',
          3000,
          null,
          null,
          'success'
        );
      }
    });
  };
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center">
            <h6>Business Data Policy</h6>
            <p>
              These settings can only be updated by the Super Admin. Contact
              support to make any changes.
            </p>
            <Separator className="mb-3" />
          </div>
          <Row className="">
            <Colxx md={12} className="mt-2">
              <h6>Security Settings</h6>
              <div className="d-flex w-100 mt-1">
                <Switch
                  className="agentswitch custom-switch-primary custom-switch-small"
                  checked={checkedPrimarySmall}
                  onChange={(primary) => handleSwitchChange(primary)}
                  disabled={!superAdmin}
                />
                <Label className="ml-2"> Don't store ticket Information</Label>
              </div>
              <div className="d-flex w-100 mt-2">
                <Switch
                  className="agentswitch custom-switch-primary custom-switch-small"
                  checked={automateTicket}
                  onChange={(primary) => handleAutomateTicket(primary)}
                  disabled={!superAdmin}
                />
                <Label className="ml-2">
                  {' '}
                  Create tickets automatically by analyzing conversation data
                </Label>
              </div>
            </Colxx>
            <Colxx md={12} className="mt-2">
              <Label>Data Retention Period for Conversations</Label>
              <div className="align-vertical-center">
                <Input
                  type="number"
                  value={propertyDataPolicy.conversationPeriod}
                  style={{ width: '100px' }}
                  onChange={(e) => handleChange(e)}
                  disabled={!superAdmin}
                  name="conversationPeriod"
                  max="84"
                  min="0"
                />{' '}
                <span className="ml-1">Months</span>
              </div>
            </Colxx>
            <Colxx md={12} className="mt-2">
              <Label>Data Retention Period for Tickets</Label>
              <div className="align-vertical-center">
                <Input
                  type="number"
                  value={propertyDataPolicy.ticketPeriod}
                  style={{ width: '100px' }}
                  onChange={(e) => handleChange(e)}
                  disabled={!superAdmin}
                  name="ticketPeriod"
                  max="84"
                  min="0"
                />{' '}
                <span className="ml-1">Months</span>
              </div>
            </Colxx>
            <Colxx md={12} className="mt-2">
              <Label>Data Retention Period for Contact Information</Label>
              <div className="align-vertical-center">
                <Input
                  type="number"
                  value={propertyDataPolicy.contactInfoPeriod}
                  style={{ width: '100px' }}
                  name="contactInfoPeriod"
                  max="84"
                  min="0"
                  onChange={(e) => handleChange(e)}
                  disabled={!superAdmin}
                />{' '}
                <span className="ml-1">Months</span>
              </div>
            </Colxx>
            {superAdmin === true && (
              <Colxx md={12} className="mt-2">
                <div className="mb-1 mt-4 ml-2 text-center">
                  <Button
                    color="primary"
                    size="xs"
                    className="mt-1"
                    onClick={() => handleSave()}
                  >
                    Save
                  </Button>
                </div>
              </Colxx>
            )}
          </Row>
        </CardBody>
      </Card>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
